import { render, staticRenderFns } from "./moreOUH.vue?vue&type=template&id=5e799da4&lang=pug&"
import script from "./moreOUH.vue?vue&type=script&lang=js&"
export * from "./moreOUH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports